import {MediaQuery} from '@services/MediaQuery'
import anime from 'animejs'

import {Component} from 'lowkey-component'
import {ColorKeys, colorKeysMap, colorsMap} from '@services/utils'

export class Backdrop extends Component {

  static entryMap = new Map()
  static currentTarget: HTMLElement | undefined = undefined
  observer: IntersectionObserver | null = null
  body: HTMLElement | null =null
  private mq = MediaQuery.create()

  didMount() {
    this.body = document.querySelector('body') as HTMLElement

    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: '0px',
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      // threshold: [0.3, 0.4, 0.5, 0.6, 0.7],
    })
    this.observer.observe(this.element)
  }

  didUnmount() {
    this.body = null
    Backdrop.entryMap.clear()
    this.observer?.disconnect()
  }

  changeClass(element: HTMLElement, color: ColorKeys) {
    if (color === 'black') {
      element.classList.remove('gray')
      element.classList.remove('white')
      element.classList.add('black')
    }
    if (color === 'white') {
      element.classList.remove('gray')
      element.classList.remove('black')
      element.classList.add('white')
    }
    if (color === 'gray') {
      element.classList.remove('white')
      element.classList.remove('black')
      element.classList.add('gray')
    }
  }

  process(element: HTMLElement) {
    if (this.body && Backdrop.currentTarget !== element) {
      const color = element.dataset['color'] as ColorKeys
      this.changeClass(this.body, color)
      const targets = [...document.querySelectorAll('.js-backdrop-target')] as HTMLDivElement[]
      targets.map(target => {
        const prop = target.dataset['prop'] as string
        const media = target.dataset['media']
        if (media && media !== this.mq.mode) {
          return
        }
        anime({
          duration: 800,
          easing: 'easeOutSine',
          targets: target,
          [prop]: colorsMap[color],
        })
        this.changeClass(target, colorKeysMap[color])
      })
      Backdrop.currentTarget = element
    }
  }

  onIntersection = (entries: IntersectionObserverEntry[]) => {
    const entryMap = Backdrop.entryMap
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entryMap.set(entry.target, entry)
      }
    }

    const filteredEntryMap = Array.from(entryMap).filter(o => {
      const {target} = o[1]
      return target.style.display !== 'none'
    })
    const maxHeight = Math.max(...Array.from(filteredEntryMap)
    .map(o => o[1].intersectionRect.height))
    const [, maxEntry] = Array.from(filteredEntryMap).find(o => {
      const height = o[1].intersectionRect.height
      return height === maxHeight
    }) || []

    const target = maxEntry?.target
    // console.log({
    //   target: target,
    //   entryMap: [...filteredEntryMap].map(([, e]) => ({
    //     t: e.target,
    //     r: e.intersectionRatio,
    //     h: e.intersectionRect.height,
    //     top: e.intersectionRect.top
    //   }))
    // })
    if (target && target.classList.contains('js-backdrop')) {
      this.process(maxEntry.target)
    }

  }

}
